class MccCountdown extends HTMLElement {
  connectedCallback() {
    this.end = Date.parse(this.dataset.end || '');
    if (!Number.isFinite(this.end)) { this.hidden = true; return; }
    this.tick(); if (this.end > Date.now()) this.timer = setInterval(() => this.tick(), 1000);
  }
  disconnectedCallback() { clearInterval(this.timer); }
  tick() {
    const seconds = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
    if (!seconds) { const parent = this.closest('[data-mcc-expiring]'); parent?.querySelector('dialog[open]')?.close(); parent?.setAttribute('hidden', ''); clearInterval(this.timer); return; }
    const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
    this.querySelectorAll('[data-time]').forEach((node, i) => { const value = String(values[i]).padStart(2, '0'); if (node.textContent !== value) node.textContent = value; });
  }
}
customElements.define('mcc-countdown', MccCountdown);
class MccReviewCarousel extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    const track = this.querySelector('.mcc-reviews-compact__track');
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', () => track.scrollBy({left: (button.hasAttribute('data-review-prev') ? -1 : 1) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}), {signal: this.abort.signal}));
  }
  disconnectedCallback() { this.abort?.abort(); }
}
customElements.define('mcc-review-carousel', MccReviewCarousel);
class MccSignup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog'); if (!this.dialog) return;
    this.abort = new AbortController();
    this.querySelector('[data-popup-close]').addEventListener('click', () => this.dialog.close(), {signal: this.abort.signal});
    this.dialog.addEventListener('click', e => { if (e.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close(); } }, {signal: this.abort.signal});
    this.key = 'mcc-signup-' + this.dataset.campaign;
    const show = () => {
      if (this.hidden || this.closest('[hidden]') || document.querySelector('dialog[open]')) return;
      this.dialog.showModal();
      try { localStorage.setItem(this.key, String(Date.now())); } catch {}
    };
    if (this.querySelector('[data-signup-result]')) { show(); return; }
    let last = 0; try { last = Number(localStorage.getItem(this.key)); } catch {}
    const frequencyDays = Math.min(30, Math.max(1, Number(this.dataset.frequencyDays) || 7));
    if (!window.Shopify?.designMode && Date.now() - last > frequencyDays * 86400000) this.timer = setTimeout(show, Number(this.dataset.delay || 12) * 1000);
    this.addEventListener('shopify:section:select', show, {signal: this.abort.signal});
    this.closest('.shopify-section')?.addEventListener('shopify:section:select', show, {signal: this.abort.signal});
    this.closest('.shopify-section')?.addEventListener('shopify:section:deselect', () => this.dialog.close(), {signal: this.abort.signal});
  }
  disconnectedCallback() { clearTimeout(this.timer); this.dialog?.close(); this.abort?.abort(); }
}
customElements.define('mcc-signup', MccSignup);
